import React, { memo } from 'react'
import { Box } from '@mui/material'

/**
 * Empty pane fill while dashboard layout is loading (no chart placeholder).
 * Uses background.paper to match the chart surface.
 */
const DashboardPaneBackground = () => (
    <Box
        sx={{
            width: '100%',
            height: '100%',
            minHeight: 0,
            bgcolor: 'background.paper'
        }}
    />
)

export default memo(DashboardPaneBackground)
